<template>
  <svg
    :width="width"
    :height="height"
    version="1.1"
    viewBox="0 0 157.69 157.69"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  >
    <metadata>
      <rdf:RDF>
        <cc:Work rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title />
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
      transform="translate(-26.156,-69.656)"
      stroke-width=".26458"
    >
      <ellipse
        cx="70.559"
        cy="113.12"
        rx="48.109"
        ry="36.349"
        opacity="0"
      />
      <ellipse
        cx="98.355"
        cy="124.61"
        rx="21.382"
        ry="29.132"
        opacity="0"
      />
      <ellipse
        cx="82.319"
        cy="90.668"
        rx="44.367"
        ry="34.21"
        opacity="0"
      />
    </g>
    <circle
      cx="78.844"
      cy="78.844"
      r="78.844"
      fill="#1c2434"
      fill-opacity=".94118"
      fill-rule="evenodd"
      stroke-width=".47719"
    />
    <g
      transform="matrix(.10253 0 0 .10253 27.581 18.058)"
      fill="#fff"
    >
      <g
        transform="matrix(.074589 0 0 -.074589 127.06 508.94)"
        fill="#fff"
        stroke="#000"
      >
        <path
          d="m886.3 4990.3c-126.3-30.6-191.3-95.6-191.3-193.2 0-168.3 101.4-237.2 296.5-202.8 65 13.4 181.7 23 256.4 23 128.2 0 143.5 3.8 195.1 55.5 95.7 97.6 68.9 262.1-53.6 325.2-55.4 28.7-373 23-503.1-7.7z"
        />
        <path
          d="m2039.9 4999.9c-24.9-9.6-61.2-45.9-82.3-80.4-53.6-86.1-40.2-179.8 38.3-248.7 57.4-53.6 59.3-53.6 340.5-53.6 237.2 0 287 5.7 321.4 34.4 105.2 84.2 112.9 208.5 19.1 302.3l-65 65-264-1.9c-147.3 0.1-285-7.5-308-17.1z"
        />
        <path
          d="m3228 4954c-93.7-93.7-86.1-218.1 19.1-302.3 34.4-28.7 84.2-34.4 321.4-34.4 281.2 0 283.1 0 340.5 53.6 109.1 95.7 80.4 279.3-49.7 329.1-26.8 11.5-164.5 19.1-308 19.1h-258.3z"
        />
        <path
          d="m4511.7 4996.1c-70.8-38.3-105.2-99.5-105.2-183.7 0-67 11.5-93.8 55.5-139.7l55.5-55.5h581.5l55.5 55.5c44 44 55.5 72.7 55.5 135.8 0 177.9-63.1 210.4-405.6 210.4-147.3 0.1-269.8-9.4-292.7-22.8z"
        />
        <path
          d="m5694 4762.7c-65.1-30.6-120.5-116.7-120.5-189.4 0-24.9 21.1-74.6 47.8-111 103.3-141.6 137.8-200.9 160.7-267.8 30.6-93.7 97.6-153 191.3-164.5 68.9-9.6 84.2-3.8 145.4 57.4 53.6 53.6 67 82.3 67 141.6 0 170.3-242.9 529.9-373 551-30.7 5.6-84.3-2-118.7-17.3z"
        />
        <path
          d="m233.9 4397.3c-80.3-44-116.7-162.6-126.3-401.8-11.5-241.1 3.8-298.4 93.8-353.9 80.3-49.7 176-38.3 243 28.7 44 44 51.7 70.8 67 264 26.8 355.8 26.8 371.2-28.7 426.6-61.3 59.3-178 78.5-248.8 36.4z"
        />
        <path
          d="m5877.6 3547.9-55.5-55.5v-581.6l55.5-55.5c44-44 72.7-55.5 135.8-55.5 176 0 210.4 63.1 210.4 401.8 0 147.3-9.6 267.8-21 292.7-36.3 72.7-97.6 109.1-185.5 109.1-66.9-0.1-93.7-11.6-139.7-55.5z"
        />
        <path
          d="m186.1 3148c-72.7-57.4-84.2-107.1-84.2-367.3 0-338.6 34.4-401.8 210.4-401.8 63.1 0 91.8 11.5 135.8 55.5l55.5 55.5v581.6l-55.5 55.5c-45.9 44-72.7 55.5-139.7 55.5-49.6-0.1-99.3-13.5-122.3-34.5z"
        />
        <path
          d="m5893 2321.5c-36.4-28.7-76.5-38.3-174.1-38.3-183.7 0-321.4-57.4-453.4-189.4-59.3-59.3-118.6-139.7-132-177.9-22.9-65-32.5-70.8-74.6-57.4-88 24.9-313.8 11.5-394.1-23-176-74.6-319.5-227.7-373.1-397.9-21-72.7-23-72.7-124.4-72.7-304.2 0-577.8-248.7-617.9-562.5l-13.4-112.8-88-24.9c-189.4-55.5-369.2-233.4-422.8-415.1-11.5-44-23-137.7-21-206.6 1.9-181.7 68.9-319.5 237.2-487.9l132-130.1v-262l-65 67-63.1 68.9h-185.6c-179.8 0-187.5-1.9-243-55.5-63.1-63.1-74.6-158.8-28.7-248.7 38.3-72.7 105.2-97.6 271.7-97.6 162.6 0 241.1 30.6 283.1 109.1 24.9 47.8 26.8 24.9 34.4-252.5 7.7-254.4 15.3-323.3 49.7-409.4 53.6-135.8 158.8-290.8 264-392.2l84.2-82.3v-868.6c0-707.9 5.7-891.5 28.7-991 86.1-363.5 396-671.5 759.5-757.6 181.7-42.1 4365.8-42.1 4547.5 0 177.9 42.1 338.6 135.8 480.2 277.4s235.3 302.3 277.4 480.2c42.1 181.7 42.1 4365.8 0 4547.5-86.1 363.5-394.1 673.4-757.6 759.5-101.4 23-302.3 28.7-1155.5 28.7h-1033.1l-350.1 350.1c-340.6 340.5-348.2 350.1-348.2 428.5 0 44-9.6 103.3-22.9 130.1-46 101.4-216.2 139.6-308 66.9zm-40.2-495.5c124.3-89.9 759.5-748 853.3-882 256.3-365.4 371.1-809.2 321.4-1235.9-103.3-859-748-1509.5-1597.5-1612.8-223.8-26.8-1029.2-26.8-1161.3 0-191.3 40.2-359.7 174.1-440 352-34.4 78.4-44 137.7-49.7 334.8l-7.7 239.1 265.9-262.1c254.4-250.6 271.7-264 344.4-264 139.7 0 243 135.8 197 260.2-11.5 30.6-279.3 313.8-595 629.4l-572 575.8v88c0 151.1 120.5 250.6 275.5 229.6 44-7.7 128.2-78.4 338.6-283.1 265.9-262.1 285.1-275.5 355.8-275.5 139.7 0 243 137.7 197 260.2-11.5 30.6-153 189.4-313.8 352-325.2 329.1-348.2 365.4-285.1 493.6 45.9 95.7 145.4 147.3 244.9 130.1 59.3-11.5 112.9-51.7 277.4-212.4 112.9-109.1 225.7-204.7 252.5-210.4 70.8-17.2 179.8 34.4 214.3 103.3 61.2 118.6 42.1 166.4-153.1 367.3-135.8 139.7-141.6 151.1-141.6 237.2 0 76.5 9.6 99.5 65 155 57.4 57.4 76.5 65 162.6 65 97.6 0 101.4-1.9 256.4-151.1 86.1-84.2 179.8-156.9 206.6-164.5 72.7-17.2 181.7 34.4 216.2 103.3 44 82.3 38.3 137.7-24.9 233.4-30.6 45.9-61.2 107.1-68.9 133.9-17.2 72.7 34.5 181.7 109.1 227.7 88.3 53.7 168.7 48 256.7-17.1zm3170-910.6c197-51.7 319.5-156.9 413.2-353.9l49.7-105.2v-4342.8l-49.7-105.2c-70.8-153-155-239.1-300.4-309.9l-128.2-63.1h-4342.7l-105.2 49.7c-197 93.8-302.3 216.2-353.9 413.2-23 88-28.7 256.3-28.7 847.5v736.6l568.2-5.7c363.5-3.8 637.1 1.9 751.8 15.3 983.3 122.5 1775.4 893.4 1922.7 1869.1 63.1 419 13.4 820.7-153.1 1212.9-36.3 88-67 162.6-67 164.5 0 3.8 386.5 5.7 857.1 5.7 696.5 0 876.3-5.8 966.2-28.7z"
        />
        <path
          d="m201.4 1919.8c-34.4-21-70.8-61.2-80.4-88-11.5-26.8-19.1-164.5-19.1-308v-258.3l65-65c93.7-93.7 218.1-86.1 302.3 19.1 28.7 34.4 34.4 84.2 34.4 321.4 0 281.2 0 283.1-51.7 340.5-70.7 78.5-164.4 91.8-250.5 38.3z"
        />
        <path
          d="m165 647.5-65-65 5.7-288.9c5.8-283.1 5.8-286.9 59.3-338.6 42.1-42.1 70.8-53.6 139.7-53.6 74.6 0 95.7 9.6 143.5 63.1l55.5 61.2v267.8c0 290.8-15.3 350.1-97.6 394.1-91.8 46-166.4 34.6-241.1-40.1z"
        />
        <path
          d="m473.1-471.6c-68.9-26.8-122.4-112.9-122.4-197.1 0-68.9 11.5-89.9 97.6-172.2 120.5-116.7 338.6-223.8 453.4-223.8 155 0 241.1 147.3 172.2 296.5-13.4 32.5-68.9 68.9-166.4 116.7-80.4 38.3-166.4 88-193.2 112.9-92 82.3-157.1 101.4-241.2 67z"
        />
        <path
          d="m1601.8-735.6c-105.2-84.2-112.9-208.5-17.2-304.2l65-65 288.9 5.7c283.1 5.7 287 5.7 338.6 59.3 42.1 42.1 53.6 70.8 53.6 139.7 0 74.6-9.6 95.7-63.1 143.5l-61.2 55.5h-283.1c-237.3-0.1-287.1-5.8-321.5-34.5z"
        />
      </g>
    </g>
    <text
      x="50%"
      y="80%"
      dominant-baseline="middle"
      text-anchor="middle"
      fill="#fff"
      font-size="8"
    >
      {{ text }}
    </text>
  </svg>
</template>

<script>
export default {
  name: 'DragAndDropIcon',
  props: {
    text: {
      type: String,
      required: true,
      default: '',
    },
    width: {
      type: String,
      required: true,
      default: '0px',
    },
    height: {
      type: String,
      required: true,
      default: '0px',
    },
  },
};
</script>
